<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner label="Spinning"></b-spinner>
    </div>

    <div v-else>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary me-2" @click="deleteFile()">
          Elimina
        </button>
        <button class="btn btn-primary me-2" @click="downloadFile()">
          Download
        </button>
        <button class="btn btn-primary">Crea link temporaneo</button>
      </div>

      <div class="preview-area mt-5" v-if="isSupportedFileType">
        <div v-if="fileType === 'immagini'">
          <div class="text-center">
            <img :src="url" alt="Preview immagine" class="img-fluid" />
          </div>
        </div>

        <div v-if="fileType === 'video'">
          <video :src="url" class="w-100" controls preload="metadata"></video>
        </div>
      </div>

      <div v-else>
        <div v-if="thumbnail" class="text-center">
          <img :src="thumbnail" alt="Preview immagine" class="img-fluid" />
        </div>
        <div class="text-center mt-4" v-else>
          <h5>
            Preview non supportata per questa tipologia di file. <br />
            Scarica il file per visualizzarlo
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilesService from "@/services/files";

export default {
  data() {
    return {
      loading: false,
      uuid: null,
      url: "",
      thumbnail: undefined,
      fileType: "",
      file: null,
    };
  },
  computed: {
    isSupportedFileType() {
      const supportedFileTypes = ["immagini", "video", "audio"];

      return supportedFileTypes.includes(this.fileType);
    },
  },
  methods: {
    async getFile() {
      this.loading = true;

      try {
        const uuid = this.$route.params.uuid;
        const data = await FilesService.getFileByUUID(this.$db, uuid);
        const file = data.data();

        this.file = file;
        this.uuid = uuid;
        this.url = file.url;
        this.thumbnail = file.thumbnail;
        this.fileType = file.fileType.value;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async deleteFile() {
      const conf = confirm("Sei sicuro di voler eliminare questo documento?");

      if (conf === true) {
        FilesService.deleteFile(this.$db, this.uuid);

        this.$router.push({ name: "DashboardPage" });
      }
    },

    async downloadFile() {
      await FilesService.updateDownloadsCounter(this.$db, this.uuid);

      const a = document.createElement("a");

      a.href = this.url;

      a.setAttribute("download", this.file.name);
      a.click();
    },
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Preview");

    this.getFile();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/preview/PreviewPage.vue